import {IconBox, IconProps} from "../index";
import React from "react";

import FacebookSvg from "../../../../assets/icons/social/facebook.svg?react";

export const FacebookIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <FacebookSvg/>
        </IconBox>
    );
}
